import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import moment from 'moment';
import CheckoutUtils from 'checkout/checkout-utils';
import SegmentUtils from 'utils/segment';
import UserUtils from 'user/user-utils';
import getParkingType from '../utils/parking-type';
import getUserLocation from '../utils/user-location';

export default function trackCheckoutStepCompleted({
    checkoutData: {
        isMonthly,
        spot: {
            facility: {
                parking_spot_id: facilityId,
                title,
                airport,
                operator_id: operatorId,
            },
        },
        promoCode,
        user: {status, email},
        phone,
        eventId,
        vehicleSelectRequired,
        vehicleMake,
        vehicleModel,
        vehicleId,
    },
    reservation: {
        city: {slug: citySlug},
        starts,
        ends,
        reservation_id: rentalId,
        currency_type: currency,
        license_plate: licensePlate,
        price,
        price_breakdown: priceBreakdown,
    },
    isAirport,
    changedDateTimeCount,
    searchStarts,
    searchEnds,
    initMoment,
}) {
    const now = moment();
    const isEvent = Boolean(eventId);
    const oversizeFee = CheckoutUtils.getOversizeFeeFromPriceBreakdown(
        priceBreakdown
    );
    const reservationStart = moment(starts);
    const reservationEnd = moment(ends);
    const vehicleInfo = {
        ...(vehicleMake && {vehicle_make: vehicleMake}),
        ...(vehicleModel && {vehicle_model: vehicleModel}),
        ...(vehicleId && {
            vehicle_profile_id: isString(vehicleId)
                ? parseInt(vehicleId, 10)
                : vehicleId,
        }),
    };
    const parkingType = getParkingType({isMonthly, isAirport, isEvent});
    const properties = {
        'promo code used': Boolean(promoCode), // MARKED FOR DEPRECATION: promo_code_used will be used moving forward
        'checkout started to purchase': now.diff(
            // MARKED FOR DEPRECATION: checkout_started_to_purchase will be used moving forward
            initMoment,
            'seconds'
        ),
        'parking type': parkingType, // MARKED FOR DEPRECATION: parking_type will be used moving forward
        'date/time update count': changedDateTimeCount || 0, // MARKED FOR DEPRECATION
        'search start time': moment(searchStarts).toISOString(), // MARKED FOR DEPRECATION
        'search end time': isMonthly // MARKED FOR DEPRECATION
            ? null
            : moment(searchEnds).toISOString(),
        ...(promoCode && {'promo code string': promoCode.code}), // MARKED FOR DEPRECATION: products.coupon will be used moving forward
        ...(isAirport && {
            airport_code: airport.details.code,
        }),
        checkout_started_to_purchase: now.diff(initMoment, 'seconds'),
        city: citySlug,
        currency,
        email,
        entered_phone_number: !isEmpty(phone),
        ...(isEvent && {event_id: eventId}),
        ...(!isEmpty(licensePlate) &&
            licensePlate !== 'DONTKNOW' && {license_plate: licensePlate}),
        operator_id: operatorId,
        oversized_vehicle: Boolean(oversizeFee),
        parking_spot_id: facilityId,
        parking_spot_name: title,
        parking_type: parkingType,
        products: [
            {
                category: parkingType,
                ...(promoCode && {coupon: promoCode.code}),
                name: title,
                price,
                product_id: String(facilityId),
                quantity: 1,
            },
        ],
        promo_code_used: Boolean(promoCode),
        rental_end_time_utc: reservationEnd.toISOString(),
        rental_id: rentalId,
        rental_lead_time: reservationStart.diff(now, 'minutes'),
        rental_length: reservationEnd.diff(reservationStart, 'minutes'),
        rental_start_time_utc: reservationStart.toISOString(),
        ...getUserLocation(),
        user_logged_in: status === UserUtils.AUTH_STATE.USER,
        ...(vehicleSelectRequired && !isEmpty(vehicleInfo) && vehicleInfo),
    };

    SegmentUtils.track({
        event: 'Checkout Step Completed',
        properties,
        additionalOptions: {
            context: {
                protocols: {
                    event_version: 2,
                },
            },
        },
    });
}
